import React, { useState } from "react";
import GlassCard from "./GlassCard";
import physiosData from "../data/physios";

const PhysioCarousel = ({ lang = "sl" }) => {
  // pick list for current language
  const physios = physiosData[lang] || physiosData.sl;

  const [index, setIndex] = useState(0);
  const current = physios[index];

  const go = (direction) => {
    setIndex((prev) => {
      const next = direction === "next" ? prev + 1 : prev - 1;
      if (next < 0) return physios.length - 1;
      if (next >= physios.length) return 0;
      return next;
    });
  };

  const heading =
    lang === "en"
      ? "Meet Our Expert Physiotherapists"
      : "Spoznaj naše strokovne fizioterapevte";
  const intro =
    lang === "en"
      ? "Our team of certified professionals brings decades of combined experience and specialized expertise to help you achieve your health goals."
      : "Naša ekipa licenciranih fizioterapevtov ima dolgoletne izkušnje in specializirana znanja, da ti pomaga doseči svoje cilje.";

  return (
    <section>
      <div className="container" style={{ maxWidth: 1040 }}>
        <h2
          style={{
            textAlign: "center",
            marginBottom: 8,
            color: "#176B87",
            fontSize: 28,
          }}
        >
          {heading}
        </h2>
        <p
          style={{
            textAlign: "center",
            marginBottom: 32,
            color: "var(--text-muted)",
            maxWidth: 720,
            marginInline: "auto",
          }}
        >
          {intro}
        </p>

        <GlassCard
          style={{
            position: "relative",
            padding: "32px 42px 26px",
            borderRadius: 32,
          }}
        >
          {/* arrows */}
          <button
            onClick={() => go("prev")}
            style={arrowStyle("left")}
            aria-label="Previous physiotherapist"
          >
            <span style={{ transform: "translateX(-2px)", transform: "translateY(-4px)" }}>‹</span>
          </button>
          <button
            onClick={() => go("next")}
            style={arrowStyle("right")}
            aria-label="Next physiotherapist"
          >
            <span style={{ transform: "translateX(2px)", transform: "translateY(-4px)" }}>›</span>
          </button>

          {/* card content */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "auto 1fr",
              gap: 24,
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: 88,
                height: 88,
                borderRadius: "999px",
                backgroundColor: "#176B87",
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 30,
                fontWeight: 700,
                overflow: "hidden",
              }}
            >
              {current.img ? (
                <img
                  src={current.img}
                  alt={current.name}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                  }}
                />
              ) : (
                <span>{current.initials}</span>
              )}
            </div>

            <div>
              <h3 style={{ margin: 0, fontSize: 22 }}>{current.name}</h3>
              <p
                style={{
                  marginTop: 4,
                  marginBottom: 12,
                  color: "#176B87",
                  fontWeight: 600,
                }}
              >
                {current.specialty}
              </p>

              <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
                <span
                  key={current.email}
                  style={{
                    padding: "4px 10px",
                    borderRadius: 999,
                    backgroundColor: "rgba(255,255,255,0.85)",
                    fontSize: 12,
                    fontWeight: 600,
                    color: "var(--text-muted)",
                  }}
                >
                  {current.email}
                </span>
                <span
                  key={current.tel}
                  style={{
                    padding: "4px 10px",
                    borderRadius: 999,
                    backgroundColor: "rgba(255,255,255,0.85)",
                    fontSize: 12,
                    fontWeight: 600,
                    color: "var(--text-muted)",
                  }}
                >
                  {current.tel}
                </span>
                <span
                  key={current.website}
                  style={{
                    padding: "4px 10px",
                    borderRadius: 999,
                    backgroundColor: "rgba(255,255,255,0.85)",
                    fontSize: 12,
                    fontWeight: 600,
                    color: "var(--text-muted)",
                  }}
                >
                  {current.website}
                </span>

              </div>

              <p
                style={{
                  marginTop: 0,
                  marginBottom: 16,
                  color: "var(--text-muted)",
                }}
              >
                {current.description}
              </p>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 16,
                  marginTop: 16,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    color: "var(--text-muted)",
                    fontSize: 14,
                  }}
                >
                  <span>👤</span>
                  <span>{current.experienceLabel}</span>
                </div>

              </div>
            </div>
          </div>

          {/* dots – map over physios, not physiosData */}
          <div
            style={{
              marginTop: 24,
              display: "flex",
              justifyContent: "center",
              gap: 8,
            }}
          >
            {physios.map((_, i) => (
              <span
                key={i}
                style={{
                  width: i === index ? 24 : 10,
                  height: 10,
                  borderRadius: 999,
                  backgroundColor:
                    i === index ? "#176B87" : "rgba(255,255,255,0.7)",
                  transition: "all 0.2s ease",
                }}
              />
            ))}
          </div>
        </GlassCard>
      </div>
    </section>
  );
};

const arrowStyle = (side) => ({
  position: "absolute",
  top: "50%",
  transform: "translateY(-50%)",
  [side]: -18,
  width: 40,
  height: 40,
  borderRadius: "999px",
  backgroundColor: "rgba(255,255,255,0.9)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "0 10px 22px rgba(0,0,0,0.18)",
  fontSize: 24,
  color: "var(--text-main)",
});

export default PhysioCarousel;
